/* CustomSolo Critical JS — Embedded inline for file:// Safari compatibility
   This script provides essential interactivity even when the external main.js
   fails to load (e.g. Safari file:// security restrictions). */
(function(){
  function ready(fn){if(document.readyState!=='loading'){fn()}else{document.addEventListener('DOMContentLoaded',fn)}}

  ready(function(){

    /* ── MEGA MENU TEMPLATE INJECTION ── */
    document.querySelectorAll('.dropdown-menu[data-menu-id]').forEach(function(menu){
      var id = menu.getAttribute('data-menu-id');
      var source = document.querySelector('.mega-menu-data-source[data-menu-id="' + id + '"]');
      if (source) {
        var grid = source.querySelector('.dropdown-grid');
        if (grid) { menu.innerHTML = grid.innerHTML; }
      }
    });

    /* ── SNOW ANIMATION ── */
    var sc = document.getElementById('snowContainer');
    if (sc) {
      var flakes = ['❄','❅','❆','✦','✧'];
      for (var i = 0; i < 30; i++) {
        var f = document.createElement('div');
        f.className = 'snowflake';
        f.textContent = flakes[Math.floor(Math.random()*flakes.length)];
        f.style.left = (Math.random()*100) + '%';
        f.style.fontSize = (Math.random()*14+10) + 'px';
        f.style.animationDuration = (Math.random()*8+8) + 's';
        f.style.animationDelay = (Math.random()*10) + 's';
        f.style.opacity = Math.random()*0.5+0.3;
        sc.appendChild(f);
      }
    }

    /* ── FIXED HEADER SCROLL ── */
    var siteHeader = document.querySelector('.site-header');
    var annBar = document.querySelector('.announcement-bar');
    var ticking = false;

    /* Recalc announcement bar height on resize (narrow screens may wrap) */
    function recalcAnnbarHeight() {
      if (annBar) {
        var h = annBar.offsetHeight;
        document.documentElement.style.setProperty('--annbar-h', h + 'px');
      }
    }
    window.addEventListener('resize', recalcAnnbarHeight);
    recalcAnnbarHeight(); /* set immediately on load */

    if (siteHeader) {
      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            var scrollY = window.pageYOffset || document.documentElement.scrollTop;
            siteHeader.classList.toggle('is-scrolled', scrollY > 10);
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
      if ((window.pageYOffset || document.documentElement.scrollTop) > 10) {
        siteHeader.classList.add('is-scrolled');
      }
    }

    /* ── MOBILE MENU ── */
    window.__MOBILE_MENU_INITIALIZED__ = true;
    var mt = document.getElementById('mobile-menu-toggle');
    var mn = document.getElementById('mobile-nav');
    var mo = document.querySelector('.mobile-nav-overlay');
    if (mt && mn) {
      mt.addEventListener('click', function(){
        mn.classList.toggle('open');
        mt.classList.toggle('active');
        if (mo) { mo.classList.toggle('show'); }
      });
      mn.querySelectorAll('a').forEach(function(a){
        a.addEventListener('click', function(){
          mn.classList.remove('open'); mt.classList.remove('active');
          if (mo) mo.classList.remove('show');
        });
      });
    }

    /* ── LOOKBOOK SWIPE DOTS ── */
    var lookbookEl = document.getElementById('lookbookScenes');
    var sceneDots = document.getElementById('sceneDots');
    if (lookbookEl && sceneDots) {
      var dotEls = sceneDots.querySelectorAll('.scene-dot');
      var cards = lookbookEl.querySelectorAll('.scene-card');
      function updateDots() {
        if (window.innerWidth >= 768) { sceneDots.style.display = 'none'; return; }
        sceneDots.style.display = 'flex';
        var scrollCenter = lookbookEl.scrollLeft + lookbookEl.clientWidth / 2;
        var activeIdx = 0, minDist = Infinity;
        cards.forEach(function(card, i) {
          var dist = Math.abs(card.offsetLeft + card.offsetWidth / 2 - scrollCenter);
          if (dist < minDist) { minDist = dist; activeIdx = i; }
        });
        dotEls.forEach(function(d, i) { d.classList.toggle('active', i === activeIdx); });
      }
      dotEls.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var idx = parseInt(this.dataset.index);
          if (cards[idx]) {
            cards[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });
      lookbookEl.addEventListener('scroll', updateDots, { passive: true });
      window.addEventListener('resize', updateDots);
      updateDots();
    }

    /* ── HOTSPOT TAP (mobile: tap to reveal labels) ── */
    document.querySelectorAll('.hotspot-dot').forEach(function(dot) {
      dot.addEventListener('click', function() {
        this.classList.toggle('tapped');
      });
    });

    /* ── SORT ── */
    var ss = document.getElementById('sort-select');
    var gc = document.querySelector('.product-grid');
    if (ss && gc) {
      ss.addEventListener('change', function(){
        var cardList = Array.from(gc.querySelectorAll(':scope > .product-card'));
        var v = ss.value;
        cardList.sort(function(a,b){
          var pa = parseFloat(a.dataset.price||'0');
          var pb = parseFloat(b.dataset.price||'0');
          return v==='price-asc'?pa-pb : v==='price-desc'?pb-pa : 0;
        });
        cardList.forEach(function(c){gc.appendChild(c);});
      });
    }

    /* ── GALLERY THUMBNAILS ── */
    var mi = document.querySelector('.gallery-main img');
    var ths = document.querySelectorAll('.gallery-thumb');
    if (mi && ths.length) {
      ths.forEach(function(t){
        t.addEventListener('click', function(){
          var ns = t.querySelector('img') && t.querySelector('img').src;
          if (!ns) return;
          mi.style.opacity = '0';
          setTimeout(function(){mi.src=ns; mi.style.opacity='1';}, 150);
          ths.forEach(function(x){x.classList.remove('active');});
          t.classList.add('active');
        });
      });
    }

    /* ── TABS ── */
    var tbs = document.querySelectorAll('.tab-btn');
    var tcs = document.querySelectorAll('.tab-content');
    if (tbs.length) {
      tbs.forEach(function(b){
        b.addEventListener('click', function(){
          var tgt = b.dataset.tab;
          tbs.forEach(function(x){x.classList.remove('active');});
          tcs.forEach(function(x){x.classList.remove('active');});
          b.classList.add('active');
          var c = document.getElementById(tgt);
          if (c) c.classList.add('active');
        });
      });
    }

    /* ── QUANTITY CONTROLS ── */
    document.querySelectorAll('.qty-btn').forEach(function(b){
      b.addEventListener('click', function(){
        var input = b.parentElement.querySelector('.qty-value');
        if (!input) return;
        var v = parseInt(input.value) || 1;
        if (b.dataset.action==='minus' && v>1) input.value = v-1;
        if (b.dataset.action==='plus') input.value = v+1;
      });
    });

    /* ── ADD TO CART ── */
    document.querySelectorAll('.btn-add-to-cart').forEach(function(b){
      b.addEventListener('click', function(e){
        e.preventDefault();
        var orig = b.innerHTML;
        b.innerHTML = '✓ Added to Cart';
        b.disabled = true;
        b.style.background = 'var(--green)';
        var cc = document.querySelector('.cart-count');
        if (cc) cc.textContent = (parseInt(cc.textContent||'0')+1);
        setTimeout(function(){b.innerHTML=orig; b.disabled=false; b.style.background='';}, 2000);
      });
    });

    /* ── SCROLL ANIMATIONS ── */
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){if (e.isIntersecting) e.target.classList.add('animate-in');});
      }, {threshold:0.1});
      document.querySelectorAll('[data-animate]').forEach(function(el){obs.observe(el);});
    }

    /* ── FALLBACK: ensure animated elements become visible ── */
    setTimeout(function(){
      document.querySelectorAll('[data-animate]:not(.animate-in)').forEach(function(el){
        el.classList.add('animate-in');
      });
    }, 800);

  });
})();

/* ═══════════════════════════════════════════════════
   UNIFIED MULTI-DIMENSIONAL FILTER ENGINE
   Handles: recipient, material, occasion, shape, promo, price
   Also handles: section collapse, clear all, mobile toggle,
   empty state, visible count, filter badge.
   ═══════════════════════════════════════════════════ */
if (!window.__FILTERS_INITIALIZED__) {
  window.__FILTERS_INITIALIZED__ = true;
  (function(){
    var sidebar = document.querySelector('.filter-sidebar');
    if (!sidebar) return;

    var checkboxes = sidebar.querySelectorAll('.filter-checkbox[data-filter]');
    var cards = document.querySelectorAll('.product-card[data-tags]');
    if (!checkboxes.length || !cards.length) return;

    var activeFilters = {};

    function getFilterInfo(cb) {
      var v = cb.getAttribute('data-filter');
      if (!v) return { g: null, val: null };
      if (v === 'bestsellers' || v === 'featured' || v === 'new')
        return { g: 'promo', val: v };
      if (v.indexOf(':') >= 0) {
        var parts = v.split(':');
        return { g: parts[0], val: parts[1] };
      }
      return { g: null, val: null };
    }

    function matchesPrice(price, val) {
      var p = price / 100;
      if (val === 'under20') return p < 20;
      if (val === '20-30') return p >= 20 && p <= 30;
      if (val === '30-50') return p >= 30 && p <= 50;
      if (val === '50plus') return p > 50;
      return false;
    }

    function applyFilters() {
      var visibleCount = 0;
      var groups = Object.keys(activeFilters).filter(function(g) {
        return activeFilters[g].size > 0;
      });

      cards.forEach(function(card) {
        var tags = (card.getAttribute('data-tags') || '').split(' ').filter(function(t){return t.length > 0;});
        var price = parseInt(card.getAttribute('data-price') || '0', 10);
        var show = true;

        for (var i = 0; i < groups.length; i++) {
          var g = groups[i], matched = false;
          if (g === 'price') {
            activeFilters[g].forEach(function(f) {
              if (matchesPrice(price, f)) matched = true;
            });
          } else {
            activeFilters[g].forEach(function(f) {
              if (tags.indexOf(g + ':' + f) >= 0 || tags.indexOf(f) >= 0) matched = true;
            });
          }
          if (!matched) { show = false; break; }
        }

        if (show) {
          card.style.display = '';
          card.style.animation = 'fadeIn .4s ease both';
          visibleCount++;
        } else {
          card.style.display = 'none';
          card.style.animation = '';
        }
      });

      var vcEl = document.getElementById('visibleCount');
      if (vcEl) vcEl.textContent = visibleCount;
      var clearBtn = document.getElementById('clearAllFilters');
      if (clearBtn) clearBtn.style.display = groups.length > 0 ? 'inline-block' : 'none';
      var emptyEl = document.getElementById('filterEmpty');
      var gridEl = document.querySelector('.product-grid');
      if (emptyEl) emptyEl.style.display = visibleCount === 0 ? '' : 'none';
      if (gridEl) gridEl.style.display = visibleCount === 0 ? 'none' : '';

      updateFilterBadge();
    }

    function updateFilterBadge() {
      var btn = document.getElementById('filterToggleBtn');
      if (!btn) return;
      var countEl = btn.querySelector('.filter-count');
      if (!countEl) return;
      var checkedCount = sidebar.querySelectorAll('.filter-checkbox:checked').length;
      if (checkedCount > 0) {
        countEl.textContent = checkedCount;
        countEl.style.display = 'inline-flex';
        btn.style.background = '#b8302c';
        btn.style.color = '#fff';
      } else {
        countEl.style.display = 'none';
        btn.style.background = '';
        btn.style.color = '';
      }
    }

    for (var i = 0; i < checkboxes.length; i++) {
      (function(cb) {
        cb.addEventListener('change', function() {
          var info = getFilterInfo(cb);
          if (!info.g) return;
          if (!activeFilters[info.g]) activeFilters[info.g] = new Set();
          if (cb.checked) {
            activeFilters[info.g].add(info.val);
          } else {
            activeFilters[info.g].delete(info.val);
            if (activeFilters[info.g].size === 0) delete activeFilters[info.g];
          }
          applyFilters();
        });
      })(checkboxes[i]);
    }

    var toggles = sidebar.querySelectorAll('.filter-section-toggle');
    for (var t = 0; t < toggles.length; t++) {
      (function(toggle) {
        toggle.addEventListener('click', function() {
          var section = toggle.closest('.filter-section');
          if (section) section.classList.toggle('collapsed');
        });
      })(toggles[t]);
    }

    var clearBtn = document.getElementById('clearAllFilters');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        for (var j = 0; j < checkboxes.length; j++) { checkboxes[j].checked = false; }
        activeFilters = {};
        applyFilters();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  })();
}

/* ═══════════════════════════════════════════════════════
   CUSTOMEOW CUSTOMIZER — Interactive product customization
   ═══════════════════════════════════════════════════════ */
(function(){
  function ready(fn){if(document.readyState!=='loading'){fn()}else{document.addEventListener('DOMContentLoaded',fn)}}
  ready(function(){
    var uploadZone = document.getElementById('upload-zone');
    if(!uploadZone) return;

    var state = {photo:null,text:'',textColor:'gold',font:'serif',elements:['border']};
    var colorMap = {gold:'#c9a96e',red:'#b8302c',green:'#2d5a3d',navy:'#1a1a2e',white:'#ffffff'};

    window.toggleSection = function(id){
      var s = document.getElementById(id);
      if(!s) return;
      s.classList.toggle('open');
    };

    window.handlePhotoUpload = function(event){
      var file = event.target.files[0];
      if(!file) return;
      var reader = new FileReader();
      reader.onload = function(e){
        state.photo = e.target.result;
        uploadZone.classList.add('has-photo');
        document.getElementById('upload-empty').style.display = 'none';
        document.getElementById('upload-preview').style.display = 'block';
        document.getElementById('preview-thumb-img').src = e.target.result;
        document.getElementById('preview-name').textContent = file.name;
        document.getElementById('preview-size').textContent = file.size < 1048576 ? (file.size/1024).toFixed(0)+' KB' : (file.size/1048576).toFixed(1)+' MB';
        updatePreview();
        document.getElementById('step-num-upload').classList.add('done');
        document.getElementById('step-num-upload').innerHTML = '&check;';
        var h = document.getElementById('hint-upload');
        h.textContent = 'Done'; h.style.color = '#2d5a3d';
      };
      reader.readAsDataURL(file);
    };

    window.updateCharCount = function(){
      var cv = document.getElementById('custom-text').value;
      document.getElementById('char-count').textContent = cv.length+'/30';
      state.text = cv;
      updatePreview();
    };

    window.selectColor = function(el){
      var p = el.parentElement;
      p.querySelectorAll('.color-swatch').forEach(function(s){s.classList.remove('selected')});
      el.classList.add('selected');
      state.textColor = el.dataset.color;
      updatePreview();
    };

    window.selectFont = function(el){
      var p = el.parentElement;
      p.querySelectorAll('.font-option').forEach(function(f){f.classList.remove('selected')});
      el.classList.add('selected');
      state.font = el.dataset.font;
      updatePreview();
    };

    window.toggleElement = function(el){
      el.classList.toggle('selected');
      var elem = el.dataset.element;
      if(el.classList.contains('selected')){
        if(state.elements.indexOf(elem)===-1) state.elements.push(elem);
      }else{
        state.elements = state.elements.filter(function(e){return e!==elem});
      }
      updatePreview();
    };

    window.updatePreview = function updatePreview(){
      var pc = document.getElementById('preview-photo');
      var pt = document.getElementById('preview-photo-text');
      var te = document.getElementById('preview-text-el');
      var ec = document.getElementById('preview-elements');
      var bg = document.getElementById('preview-bg');

      if(state.photo){
        pt.style.display = 'none';
        var img = pc.querySelector('img');
        if(!img){img = document.createElement('img'); pc.appendChild(img);}
        img.src = state.photo; img.style.display = 'block';
      }else{
        pt.style.display = 'block';
        var ex = pc.querySelector('img'); if(ex) ex.remove();
      }

      if(state.text){
        te.textContent = state.text;
        te.style.color = colorMap[state.textColor] || '#c9a96e';
        te.style.display = 'block';
        te.style.fontSize = '13px';
        switch(state.font){
          case 'serif': te.style.fontFamily='Georgia,serif'; te.style.fontStyle='italic'; te.style.letterSpacing='normal'; te.style.fontWeight='700'; break;
          case 'sans': te.style.fontFamily='"Helvetica Neue",sans-serif'; te.style.fontStyle='normal'; te.style.letterSpacing='1px'; te.style.fontWeight='700'; break;
          case 'script': te.style.fontFamily='Georgia,serif'; te.style.fontStyle='italic'; te.style.letterSpacing='normal'; te.style.fontWeight='700'; te.style.fontSize='15px'; break;
          case 'modern': te.style.fontFamily='"Helvetica Neue",sans-serif'; te.style.fontStyle='normal'; te.style.letterSpacing='3px'; te.style.fontWeight='300'; break;
        }
      }else{ te.style.display = 'none'; }

      if(state.elements.indexOf('border')!==-1){bg.style.border='3px solid #c9a96e'}else{bg.style.border='3px solid #d0cbc0'}
      ec.innerHTML = '';
      if(state.elements.indexOf('snowflakes')!==-1){
        for(var i=0;i<6;i++){var sf=document.createElement('span'); sf.className='preview-snowflake'; sf.innerHTML='&#10052;'; sf.style.top=(10+Math.random()*80)+'%'; sf.style.left=(5+Math.random()*85)+'%'; ec.appendChild(sf);}
      }
      if(state.elements.indexOf('stars')!==-1){
        for(var i=0;i<4;i++){var st=document.createElement('span'); st.className='preview-star'; st.innerHTML='&#9733;'; st.style.top=(5+Math.random()*85)+'%'; st.style.left=(5+Math.random()*85)+'%'; ec.appendChild(st);}
      }
      if(state.elements.indexOf('year')!==-1){
        var yb=document.createElement('div'); yb.className='preview-element-label'; yb.textContent='2025'; yb.style.bottom='38px'; ec.appendChild(yb);
      }

      if(state.text){
        var nt = document.getElementById('step-num-text'); nt.classList.add('done'); nt.innerHTML='&check;';
        var ht = document.getElementById('hint-text'); ht.textContent='Done'; ht.style.color='#2d5a3d';
      }
      var selEls = state.elements.filter(function(e){return e!=='border'});
      if(selEls.length>0){
        var ne = document.getElementById('step-num-elements'); ne.classList.add('done'); ne.innerHTML='&check;';
        var he = document.getElementById('hint-elements'); he.textContent='Done'; he.style.color='#2d5a3d';
      }
    };

    window.toggleInfo = function(id){document.getElementById(id).classList.toggle('open')};

    window.saveDesign = function(){
      if(!state.photo){showToast('Please upload a photo first',false); return;}
      showToast('Design saved! Your custom gift is ready.',true);
    };

    window.addToCart = function(){
      if(!state.photo){showToast('Please upload a photo to continue',false); document.getElementById('section-upload').scrollIntoView({behavior:'smooth'}); return;}
      var btn = document.querySelector('.btn--gold.btn--lg');
      var priceText = btn ? btn.textContent.match(/\$[\d.]+/) : null;
      var titleEl = document.querySelector('.product-detail-title');
      var productName = titleEl ? titleEl.textContent.trim() : 'Item';
      showToast('Added to cart! ' + productName + ' — ' + (priceText?priceText[0]:'$0'), true);
      var badge = document.querySelector('.cart-count');
      if(badge) badge.textContent = parseInt(badge.textContent||0) + 1;
    };

    window.resetCustomizer = function(){
      state = {photo:null,text:'',textColor:'gold',font:'serif',elements:['border']};
      document.getElementById('custom-text').value = '';
      document.getElementById('char-count').textContent = '0/30';
      uploadZone.classList.remove('has-photo');
      document.getElementById('upload-empty').style.display = '';
      document.getElementById('upload-preview').style.display = 'none';
      document.querySelectorAll('#text-color-swatches .color-swatch').forEach(function(s){s.classList.remove('selected')});
      document.querySelector('#text-color-swatches .swatch-gold').classList.add('selected');
      document.querySelectorAll('#font-options .font-option').forEach(function(f){f.classList.remove('selected')});
      document.querySelector('#font-options [data-font="serif"]').classList.add('selected');
      document.querySelectorAll('#element-pills .element-pill').forEach(function(p){p.classList.remove('selected')});
      document.querySelector('#element-pills [data-element="border"]').classList.add('selected');
      ['upload','text','elements'].forEach(function(s){
        document.getElementById('step-num-'+s).classList.remove('done');
        if(s==='upload'){document.getElementById('step-num-upload').textContent='1'; var hu=document.getElementById('hint-upload'); hu.textContent='Required'; hu.style.color='';}
        if(s==='text'){document.getElementById('step-num-text').textContent='2'; var ht=document.getElementById('hint-text'); ht.textContent='Optional'; ht.style.color='';}
        if(s==='elements'){document.getElementById('step-num-elements').textContent='3'; var he=document.getElementById('hint-elements'); he.textContent='Optional'; he.style.color='';}
      });
      updatePreview();
      showToast('Design reset — start fresh!',true);
    };

    function showToast(msg,success){
      var toast = document.getElementById('toast');
      if(!toast) return;
      document.getElementById('toast-msg').textContent = msg;
      var icon = document.getElementById('toast-icon-el');
      icon.innerHTML = success ? '&check;' : '&#9888;';
      icon.style.background = success ? '#2d5a3d' : '#b8302c';
      toast.classList.add('show');
      setTimeout(function(){toast.classList.remove('show')},2500);
    }

    updatePreview();
  });
})();

/* ═══════════════════════════════════════════════════════════
   MOBILE FILTER TOGGLE — Bottom sheet drawer for collection pages
   ═══════════════════════════════════════════════════════════ */
(function(){
  function ready(fn){if(document.readyState!=='loading'){fn()}else{document.addEventListener('DOMContentLoaded',fn)}}
  ready(function(){
    var sidebar = document.querySelector('.filter-sidebar');
    if(!sidebar) return;

    /* Use existing overlay from HTML if available, otherwise create one */
    var overlay = document.getElementById('filterOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'filter-overlay';
      overlay.id = 'filterOverlay';
      document.body.appendChild(overlay);
    }

    /* Mobile filters badge count */
    var totalItems = document.querySelectorAll('.product-card').length;

    /* Open filter drawer */
    function openFilters(){
      sidebar.classList.add('mobile-open');
      overlay.classList.add('show');
      document.body.style.overflow = 'hidden';
    }

    /* Close filter drawer */
    function closeFilters(){
      sidebar.classList.remove('mobile-open');
      overlay.classList.remove('show');
      document.body.style.overflow = '';
    }

    /* Overlay click to close */
    overlay.addEventListener('click', closeFilters);

    /* Swipe-down to close on mobile */
    var touchStartY = 0;
    sidebar.addEventListener('touchstart', function(e){
      touchStartY = e.touches[0].clientY;
    }, {passive:true});
    sidebar.addEventListener('touchmove', function(e){
      var dy = e.touches[0].clientY - touchStartY;
      if (dy > 60 && sidebar.scrollTop <= 5) {
        closeFilters();
      }
    }, {passive:true});

    /* Expose open/close for filter toggle button (set in main-collection.liquid inline onclick) */
    window.openFilters = openFilters;
    window.closeFilters = closeFilters;
  });})();
